// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605121025/js/" + chunkId + "." + {"44":"5286a2ca","225":"07b2c752","481":"5cc0787e","486":"6faf6118","770":"3b58084c"}[chunkId] + ".0.470997013026772.chunk.js";
};